<template>
  <a-sub-menu
    :key="menuInfo.key"
    :class="{
      'selected-parent-menu': selectedMenu,
    }"
    v-bind="$props"
    v-on="$listeners"
  >
    <span slot="title" class="d-flex align-items-center">
      <img 
        v-if="menuInfo.sales_channel?.code"
        class="pr-2"
        :src="isChannel && menuInfo?.notes === 'tiktok_tokopedia' 
          ? require(`@/assets/store/${menuInfo?.notes}.png`) 
          : isChannel && menuInfo?.notes !== 'tiktok_tokopedia' 
            ? require(`@/assets/store/${menuInfo.sales_channel?.code.toLowerCase()}.png`) 
            : require('@/assets/images/logo_small.png')"
        :class="{ 'not-channel': !isChannel }"
        alt=""
      />
      <a-icon v-if="!menuInfo.sales_channel?.code" :type="setIcon(menuInfo.icon)" class="pr-2" style="font-size: 18px" />
      <a-tooltip v-if="!settings.isMenuCollapsed" placement="bottomLeft">
        <template slot="title">
          {{ titleMenu }}
        </template>
        <span class="menu-title">{{ titleMenu }}</span>
      </a-tooltip>
    </span>

    <template v-for="item in menuInfo.children">
      <item
        v-if="!item.children && !item.divider"
        :key="item.key"
        :menu-info="item"
      />
      <sub-menu v-if="item.children" :key="item.key" :menu-info="item" />
    </template>
  </a-sub-menu>
</template>

<script>
import { Menu } from 'ant-design-vue'
import Item from './item'

import dataItemMenu from './../composables/item'

export default {
  name: 'SubMenu',
  components: {
    Item,
  },
  isSubMenu: true,
  props: {
    ...Menu.SubMenu.props,
    menuInfo: Object,
    styles: Object,
  },
  setup(props) {
    const { settings, titleMenu, selectedMenu, setIcon } = dataItemMenu(props)

    return { settings, titleMenu, selectedMenu, setIcon }
  },
  computed: {
    isChannel() {
      return ['shopee_id','tokopedia_id', 'tiktok', 'tiktok_id', 'blibli_id', 'lazada_id', 'zalora_id', 'toco_id', 'accurate_pos'].includes(this.menuInfo.sales_channel?.code)
    },
  },
}
</script>

<style>
.not-channel {
  width: 28px;
  height: 28px;
  margin-left: 4px;
  margin-right: 4px;
  object-fit: contain;
}

.menu-title {
  display: block;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
